import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { FlowFormProps } from './DetailsForm';
import { TraitTreeComponent } from '../shared/TraitTreeComponent';

export const TraitsForm: React.FC<FlowFormProps> = props => {
  return (
    <Stack>
      <Text className="my-2" variant={'xLarge'}>
        {'Traits'}
      </Text>
      <Text className="my-2" variant={'medium'} style={{ width: 656 }}>
        <TraitTreeComponent categorizedTraits={props.currentQueue.categorizedTraits} />
      </Text>
    </Stack>
  );
};
